var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeAndPeopleHomeRenovation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2352.000000, -437.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Life-and-people/Home-renovation",
    transform: "translate(2352.000000, 437.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0.187997063 L5,5.40891549 C5,7.85194086 6.48229965,10.052028 8.69300871,10.9490922 L8.69300871,10.9490922 L18.5,14.2846418 L18.5,22 L20,22.0001562 L20,29.5000391 C20,30.8810175 18.88,32 17.5,32 C16.119,32 15,30.8810175 15,29.5000391 L15,29.5000391 L15,22.0001562 L16.5,22 L16.5,15.716763 L7.99562065,12.8226709 C4.97635866,11.5999003 3,8.66651153 3,5.40891549 L3,5.40891549 L3,0.187997063 L5,0.187997063 Z M28.558,5.68434189e-14 C28.802,5.68434189e-14 29,0.197996906 29,0.442993078 L29,9.93784472 L11.748,9.93784472 C9.125,9.93784472 7,7.81187794 7,5.18991891 L7,5.68434189e-14 L28.558,5.68434189e-14 Z",
    id: 52
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeAndPeopleHomeRenovation);
export default __webpack_public_path__ + "static/media/life-and-people-home-renovation.fb0debd8.svg";
export { ForwardRef as ReactComponent };